import { createAPI } from '../../composable/useAPI';

export const usePowerMonitorAPI = () => {
  const api = createAPI();

  const request = {
    powerMonitor: {
      get: async (params) => {
        return await api.get('/api/v2/power-monitor', { params })
          .then((res) => { return res.data.data; })
          .catch((err) => { console.error(err); return false; });
      },
    },
  };

  return {
    ...request,
  };
};
